<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between">
      <h5 class="mb-0">Filtros</h5>
      <div class="ms-auto">
        <button
          type="button"
          title="Limpar filtros"
          :disabled="isSearching"
          @click="clearFilters"
          class="btn btn-yellow border-transparent btn-sm"
        >
          <i class="ph ph-x me-2"></i> Limpar Filtros
        </button>
        <button
          type="button"
          title="Pesquisar"
          :disabled="isSearching"
          @click="search"
          class="ms-2 btn btn-success btn-sm"
        >
          <i class="ph ph-magnifying-glass me-2"></i> Pesquisar
        </button>
      </div>
    </div>
    <div class="card-body" v-if="!isLoadingParams">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row mb-2">
            <div class="col-12">
              <p><span class="fw-semibold">Data de Envio:</span></p>
            </div>
            <div class="col-6">
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="sendStartDate"
                placeholder="Data inicial"
              />
            </div>
            <div class="col-6">
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="sendEndDate"
                placeholder="Data final"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row mb-2">
            <div class="col-12">
              <p><span class="fw-semibold">Data de Resposta:</span></p>
            </div>
            <div class="col-6">
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="answerStartDate"
                placeholder="Data inicial"
              />
            </div>
            <div class="col-6">
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="answerEndDate"
                placeholder="Data final"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-md-6">
            <p><span class="fw-semibold">Pesquisas:</span></p>
            <MultiSelect
              :options="params.surveys"
              v-model="surveyId"
              :selectedOptions="surveyId"
              placeholder="Selecione uma Pesquisa"
              :hideSelectedOptions="false"
              @select="selectSurvey"
            />
          </div>
          <div class="col-12 col-md-6">
            <div class="row mb-2">
              <div class="col-12">
                <p><span class="fw-semibold">Solicitante:</span></p>
              </div>
              <div class="col-12">
                <MultiSelect
                  :options="params.requesters"
                  v-model="requester"
                  :selectedOptions="requester"
                  placeholder="Selecione um Solicitante"
                  :hideSelectedOptions="false"
                  @select="selectRequester"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <p><span class="fw-semibold">Técnico:</span></p>
            <MultiSelect
              :options="params.technicians"
              v-model="technician"
              :selectedOptions="technician"
              placeholder="Selecione um Técnico"
              :hideSelectedOptions="false"
              @select="selectTechnician"
            />
          </div>
          <div class="col-12 col-md-6 mb-2">
            <p><span class="fw-semibold">Cliente:</span></p>
            <MultiSelect
              :options="params.organizations"
              v-model="organization"
              :selectedOptions="organization"
              placeholder="Selecione um Cliente"
              :hideSelectedOptions="false"
              @select="selectOrganization"
            />
          </div>
          <div class="col-12 col-md-6 mb-2">
            <p><span class="fw-semibold">Pergunta 1:</span></p>
            <MultiSelect
              :options="params.questionOne"
              :selectedOptions="field1"
              v-model="field1"
              placeholder="Selecione uma Pergunta"
              :hideSelectedOptions="false"
              @select="selectField1"
            />
          </div>
          <div
            class="col-12 col-md-6 mb-2"
            v-show="checkInputsAvaliables('npsOptions')"
          >
            <p><span class="fw-semibold">Qualificação NPS:</span></p>
            <MultiSelect
              :options="params.npsOptions"
              :selectedOptions="npsOptions"
              v-model="npsOptions"
              placeholder="Selecione uma Qualificação"
              :hideSelectedOptions="false"
              @select="selectNpsOptions"
            />
          </div>
          <div
            class="col-12 col-md-6 mb-2"
            v-show="checkInputsAvaliables('accessTypes')"
          >
            <p><span class="fw-semibold">Acesso a Pesquisa:</span></p>
            <MultiSelect
              :options="params.accessTypes"
              :selectedOptions="accessTypes"
              v-model="accessTypes"
              placeholder="Selecione uma opção"
              :hideSelectedOptions="false"
              @select="selectAccessTypes"
            />
          </div>
          <div
            class="col-12 col-md-6 mb-2"
            v-show="checkInputsAvaliables('npsMode')"
          >
            <p><span class="fw-semibold">Tipo de NPS:</span></p>
            <ModelSelect
              :options="params.npsMode"
              :selectedOptions="npsMode"
              v-model="npsMode"
              placeholder="Selecione uma opção"
            />
          </div>
          <div
            class="col-12 col-md-6 mb-2"
            v-show="checkInputsAvaliables('startMode')"
          >
            <p><span class="fw-semibold">Número de Estrelas:</span></p>
            <MultiSelect
              :options="params.startTypes"
              :selectedOptions="startTypes"
              v-model="startTypes"
              placeholder="Selecione uma opção"
              :hideSelectedOptions="false"
              @select="selectStartTypes"
            />
          </div>
          <div
            class="col-12 col-md-6 mb-2"
            v-show="checkInputsAvaliables('feelingMode')"
          >
            <p><span class="fw-semibold">Sentimento:</span></p>
            <MultiSelect
              :options="params.feelingsTypes"
              :selectedOptions="feelingsTypes"
              v-model="feelingsTypes"
              placeholder="Selecione uma opção"
              :hideSelectedOptions="false"
              @select="selectFeelingsTypes"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MultiSelect, ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: 'SidebarFilters',

  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    inputsAvaliables: {
      type: Array,
    },
  },

  components: {
    MultiSelect,
    ModelSelect,
  },

  data() {
    return {
      isLoadingParams: true,
      params: {
        surveys: [],
        requesters: [],
        organizations: [],
        technicians: [],
        npsMode: [],
        npsOptions: [
          { text: 'Detratores', value: 'detractors' },
          { text: 'Neutros', value: 'passives' },
          { text: 'Promotores', value: 'promoters' },
        ],
        accessTypes: [
          { text: 'Não Acessados', value: 'notAccess' },
          { text: 'Visualizados sem Resposta', value: 'viewed' },
          { text: 'Respondidos Parcialmente', value: 'partiallyAnswered' },
          { text: 'Respondidos', value: 'answered' },
        ],
        startTypes: [
          { text: '1 Estrela', value: 1 },
          { text: '2 Estrelas', value: 2 },
          { text: '3 Estrelas', value: 3 },
          { text: '4 Estrelas', value: 4 },
          { text: '5 Estrelas', value: 5 },
        ],
        feelingsTypes: [
          { text: 'Positivo', value: 'positive' },
          { text: 'Neutro', value: 'neutral' },
          { text: 'Negativo', value: 'negative' },
        ],
      },
      sendStartDate: null,
      sendEndDate: null,
      answerStartDate: null,
      answerEndDate: null,
      surveyId: [],
      requester: [],
      organization: [],
      technician: [],
      field1: [],
      npsOptions: [],
      accessTypes: [],
      startTypes: [],
      feelingsTypes: [],
      npsMode: 'Total',
    }
  },

  methods: {
    async getReportParams() {
      try {
        this.isLoadingParams = true
        this.params = await this.$store.dispatch('getReportParams')
        this.params.npsOptions = [
          { text: 'Detratores', value: 'detractors' },
          { text: 'Neutros', value: 'passives' },
          { text: 'Promotores', value: 'promoters' },
        ]
        this.params.accessTypes = [
          { text: 'Não Acessados', value: 'notAccess' },
          { text: 'Visualizados sem Resposta', value: 'viewed' },
          { text: 'Respondidos Parcialmente', value: 'partiallyAnswered' },
          { text: 'Respondidos', value: 'answered' },
        ]
        this.params.npsMode = [
          { text: 'Total', value: 'Total' },
          { text: 'Parcial', value: 'Partial' },
        ]
        this.params.startTypes = [
          { text: '1 Estrela', value: 1 },
          { text: '2 Estrelas', value: 2 },
          { text: '3 Estrelas', value: 3 },
          { text: '4 Estrelas', value: 4 },
          { text: '5 Estrelas', value: 5 },
        ]
        this.params.feelingsTypes = [
          { text: 'Positivo', value: 'positive' },
          { text: 'Neutro', value: 'neutral' },
          { text: 'Negativo', value: 'negative' },
        ]
        this.isLoadingParams = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    checkInputsAvaliables(input) {
      return this.inputsAvaliables.includes(input)
    },

    selectTechnician(technician) {
      this.technician = technician
    },

    selectOrganization(organization) {
      this.organization = organization
    },

    selectSurvey(survey) {
      this.surveyId = survey
    },

    selectRequester(requester) {
      this.requester = requester
    },

    selectField1(field1) {
      this.field1 = field1
    },

    selectNpsOptions(npsOptions) {
      this.npsOptions = npsOptions
    },

    selectAccessTypes(accessTypes) {
      this.accessTypes = accessTypes
    },

    selectStartTypes(startTypes) {
      this.startTypes = startTypes
    },

    selectFeelingsTypes(feelingsTypes) {
      this.feelingsTypes = feelingsTypes
    },

    clearFilters() {
      this.sendStartDate = null
      this.sendEndDate = null
      this.answerStartDate = null
      this.answerEndDate = null
      this.surveyId = []
      this.requester = []
      this.organization = []
      this.technician = []
      this.field1 = []
      this.npsOptions = []
      this.accessTypes = []
      this.startTypes = []
      this.feelingsTypes = []
      this.npsMode = 'Total'
    },

    search() {
      this.$emit('search', {
        sendStartDate: this.sendStartDate,
        sendEndDate: this.sendEndDate,
        answerStartDate: this.answerStartDate,
        answerEndDate: this.answerEndDate,
        npsMode: this.npsMode,
        surveyId: JSON.stringify(this.surveyId.map((survey) => survey.value)),
        requester: JSON.stringify(
          this.requester.map((requester) => requester.value),
        ),
        organization: JSON.stringify(
          this.organization.map((organization) => organization.value),
        ),
        field1: JSON.stringify(this.field1.map((field1) => field1.value)),
        technician: JSON.stringify(
          this.technician.map((technician) => technician.value),
        ),
        npsOptions: JSON.stringify(
          this.npsOptions.map((npsOptions) => npsOptions.value),
        ),
        accessTypes: JSON.stringify(
          this.accessTypes.map((accessTypes) => accessTypes.value),
        ),
        feelingsTypes: JSON.stringify(
          this.feelingsTypes.map((feelingsTypes) => feelingsTypes.value),
        ),
        startTypes: JSON.stringify(
          this.startTypes.map((startTypes) => startTypes.value),
        ),
      })
    },
  },

  mounted() {
    this.getReportParams()
  },
}
</script>
